import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPinLine, ArrowRight } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { severityColor, timeAgo } from "../lib/format";

export default function AlertsPage() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    (async () => {
      const rows = await api.alerts(50);
      setAlerts(rows);
    })();
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-10 py-8 lg:py-12" data-testid="alerts-page">
      <div className="eyebrow">Regulatory-grade</div>
      <h1 className="font-heading font-light text-4xl sm:text-5xl tracking-tight mt-2">
        Region-specific <span className="font-accent italic text-[#A66E4E]">risk alerts</span>
      </h1>
      <p className="text-[#6E6B65] mt-3 max-w-xl">
        Automated monitoring flags unusual patterns — adverse reaction clusters, counterfeit
        surges, packaging failures — across monitored regions.
      </p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E2DC] border border-[#E5E2DC]">
        {alerts.map((a) => {
          const sev = severityColor(a.severity);
          return (
            <Link
              key={a.id}
              to={`/product/${a.product_id}`}
              data-testid="alert-card"
              className="bg-white p-6 hover:bg-[#EFECE6]/30 transition-colors group"
            >
              <div className="flex items-center gap-2 mb-3 flex-wrap">
                <span
                  className="text-[10px] uppercase tracking-[0.18em] font-semibold px-1.5 py-0.5"
                  style={{ background: sev.bg, color: sev.fg }}
                >
                  {a.severity}
                </span>
                <span className="eyebrow text-[9px] flex items-center gap-1">
                  <MapPinLine size={11} /> {a.region}
                </span>
                <span className="text-[10px] font-mono text-[#6E6B65] ml-auto">
                  {timeAgo(a.created_at)}
                </span>
              </div>
              <div className="font-heading text-xl leading-tight">{a.title}</div>
              <div className="eyebrow mt-2">{a.brand}</div>
              <div className="font-accent italic text-2xl text-[#1C1B1A] leading-tight">{a.product_name}</div>
              <p className="text-[13px] text-[#6E6B65] mt-3 leading-snug">{a.description}</p>
              <div className="mt-4 text-[11px] uppercase tracking-wider font-semibold text-[#A66E4E] flex items-center gap-1 group-hover:gap-2 transition-all">
                inspect product <ArrowRight size={12} weight="bold" />
              </div>
            </Link>
          );
        })}
        {alerts.length === 0 && (
          <div className="col-span-full bg-white p-10 text-center text-[#6E6B65]">
            No active alerts.
          </div>
        )}
      </div>
    </div>
  );
}
